export const DEFAULT_DAYS_EXPERIMENT_FLAG_KEY = "duration-z-15-na-21";

export const DEFAULT_DAYS_CONTROL = 15;
export const DEFAULT_DAYS_TEST = 21;

export const resolveDefaultDaysCount = (variant?: boolean | string): number =>
  variant === "test21" ? DEFAULT_DAYS_TEST : DEFAULT_DAYS_CONTROL;

export const DEFAULT_DAYS_METADATA_KEY = "default_selected_days";
export const DEFAULT_DAYS_METADATA_VERSION = "v1";

export const buildDefaultDaysMetadata = (daysCount: number) => [
  {
    key: DEFAULT_DAYS_METADATA_KEY,
    value: String(daysCount),
    version: DEFAULT_DAYS_METADATA_VERSION,
    sensitive: false,
  },
];
